import React from 'react';
import { Dispatch } from 'redux';
import modalActions from '../modules/modalsState/actions';
import { UNPROCESSABLE_ENTITY } from '@mm/constants/status-codes';
import { getErrorJson } from '@mm/utils';
import { StoreState } from '../store-interfaces';
import commonHandler from './common-handler';

const IG_ACCOUNT_NOT_CONNECTED = 'Instagram account not connected.';

export type ResponseOrError = Response | TypeError | Error;

export const instagramHandler =
  (dispatch: Dispatch<StoreState>) => async (error: ResponseOrError) => {
    if (error instanceof Response) {
      const responseErrorBody = await getErrorJson(error);
      if (error.status === UNPROCESSABLE_ENTITY && responseErrorBody.errors) {
        if (responseErrorBody.errors[0] === IG_ACCOUNT_NOT_CONNECTED) {
          dispatch(
            modalActions.openPrettyErrorModal({
              errorMessage: (
                <div>
                  In order to connect your Instagram account you must first link
                  it to your Facebook Page. Please see{' '}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://customers.ai/help/article/9thtjdqts5-connecting-your-instagram-account-to-a-facebook-page"
                  >
                    this helpdoc
                  </a>{' '}
                  for further instructions.
                </div>
              ),
              title: 'No Instagram Account Found',
            }),
          );
          return error;
        }
      } else {
        commonHandler(dispatch)(error);
      }
    } else {
      commonHandler(dispatch)(error);
    }
  };
